import React from 'react';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const email = formData.get('email');

    if (!email) {
      alert('Please enter your email address');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d5sshdjeef401v8jjd3g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({ email: email as string }).toString(),
      });

      if (response.ok) {
        form.reset();
        alert('Thank you for subscribing to our intelligence briefing!');
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      alert('Unable to submit. Please try again later.');
    }
  };

  return (
    <footer className="bg-[#0A0F0D] py-12 sm:py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 md:gap-12 mb-12 sm:mb-16">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <img 
                src="https://static.readdy.ai/image/f8a1f6f2191eae46b1c6cd6b762cbc11/ccae452333f785a31e69f772b518f429.jpeg" 
                alt="U First Doctors" 
                className="h-10 sm:h-12 md:h-14 w-10 sm:w-12 md:w-14 object-contain"
              />
            </div>
            <p className="text-[11px] sm:text-[12px] font-light text-[#606060] leading-relaxed mb-4 sm:mb-6">
              Medical Security.
            </p>
            <p className="text-[11px] sm:text-[12px] font-light text-[#606060] leading-relaxed mb-4 sm:mb-6">
              GF.
            </p>
            <div className="flex items-center gap-3 sm:gap-4">
              <a 
                href="https://www.linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-[#1A1A1A] rounded-lg hover:bg-[#2A2A2A] transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-base sm:text-[18px] text-[#A0A0A0] hover:text-[#F5F5F5]"></i>
              </a>
              <a 
                href="https://www.instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-[#1A1A1A] rounded-lg hover:bg-[#2A2A2A] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-base sm:text-[18px] text-[#A0A0A0] hover:text-[#F5F5F5]"></i>
              </a>
              <a 
                href="https://www.x.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-[#1A1A1A] rounded-lg hover:bg-[#2A2A2A] transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-base sm:text-[18px] text-[#A0A0A0] hover:text-[#F5F5F5]"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-[9px] sm:text-[10px] uppercase tracking-[0.15em] text-[#707070] mb-4 sm:mb-6">
              Intelligence Briefing
            </h4>
            <form onSubmit={handleNewsletterSubmit} data-readdy-form id="newsletter-form">
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  placeholder="Your secure email"
                  required
                  className="w-full bg-transparent border-b border-[#303030] text-xs sm:text-[13px] text-[#F5F5F5] py-2 sm:py-3 pr-8 sm:pr-10 focus:outline-none focus:border-[#505050] transition-colors placeholder:text-[#505050]"
                />
                <button type="submit" className="absolute right-0 top-1/2 -translate-y-1/2 text-[#707070] hover:text-[#F5F5F5] transition-colors cursor-pointer">
                  <i className="ri-arrow-right-line text-base sm:text-lg"></i>
                </button>
              </div>
            </form>
            <p className="text-[9px] sm:text-[10px] text-[#505050] mt-2 sm:mt-3">
              Quarterly insights. Strictly confidential.
            </p>
          </div>

          <div>
            <h4 className="text-[9px] sm:text-[10px] uppercase tracking-[0.15em] text-[#707070] mb-4 sm:mb-6">
              Quick Access
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              {[
                { label: 'Philosophy', id: 'philosophy' },
                { label: 'Services Overview', id: 'services' },
                { label: 'Training Programs', id: 'training' },
                { label: 'Credentials', id: 'credentials' },
                { label: 'Clientele', id: 'clientele' },
                { label: 'Engagement Process', id: 'approach' },
                { label: 'Contact', id: 'contact' }
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-xs sm:text-sm text-[#A0A0A0] hover:text-[#F5F5F5] transition-colors cursor-pointer text-left"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[9px] sm:text-[10px] uppercase tracking-[0.15em] text-[#707070] mb-4 sm:mb-6">
              Secure Channels
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a 
                  href="mailto:concierge@ufirstdoctorselite.com"
                  className="text-xs sm:text-sm text-[#A0A0A0] hover:text-[#F5F5F5] transition-colors cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-mail-line text-sm"></i>
                  <span>concierge@ufirstdoctorselite.com</span>
                </a>
              </li>
              <li className="text-xs sm:text-sm text-[#A0A0A0]">
                Signal: +[Encrypted]
              </li>
              <li className="text-xs sm:text-sm text-[#A0A0A0]">
                ProtonMail
              </li>
              <li className="text-xs sm:text-sm text-[#A0A0A0]">
                Direct Introduction
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1A1A1A] pt-8 sm:pt-10 md:pt-12">
          <div className="text-[40px] sm:text-[60px] md:text-[80px] lg:text-[120px] font-bold text-[#D4C4B0] leading-none tracking-tight opacity-30 mb-6 sm:mb-8 font-sans text-center lg:text-left">
            U FIRST DOCTORS
          </div>
          
          <div className="flex flex-col sm:flex-row items-center justify-between text-[10px] sm:text-[12px] text-[#606060] gap-4">
            <div className="text-center sm:text-left">
              © {new Date().getFullYear()} U First Doctors. All rights reserved.
            </div>
            <div>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#A0A0A0] transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
